var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3l0 -8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10l18 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15l.01 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15l2 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/creditcard.0423734ddf3320d7aa9c384c01c8db2e.svg";
export { ForwardRef as ReactComponent };